import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"
import api from "../api"
import { PickBasicModel, PickModel } from "../api/pick.api"

export interface PicksListState {
    suitesPick: PickModel[]
    parcelsBasic: PickBasicModel[]
    loading: boolean
    error?: string
    success?: boolean
    shipmentTracking?: Record<string, any>
    scannedSuite?: Record<string, any>
}

const initialState: PicksListState = {
    suitesPick: [],
    parcelsBasic: [],
    loading: false
}

export const loadSuitesPick = createAsyncThunk(
    "pick/suites/list",
    async ({ warehouse }: { warehouse?: string }, thunkAPI) => {
        try {
            const response = await api.pick.suitesPickList({ warehouse })

            return response
        } catch (error: any) {
            console.log(error)
            return error.message
        }
    }
)

export const loadReadyParcelsPick = createAsyncThunk(
    "pick/parcels/list",
    async ({ warehouse }: { warehouse?: string }, thunkAPI) => {
        try {
            const response = await api.pick.readyParcelsPickList({ warehouse })

            return response
        } catch (error: any) {
            console.log(error)
            return error.message
        }
    }
)

export const pickParcel = createAsyncThunk(
    "pick/parcel",
    async ({ parcelUuid }: { parcelUuid: string }, thunkAPI) => {
        try {
            const response = await api.pick.pickParcel({ parcelUuid })

            return response
        } catch (error: any) {
            thunkAPI.rejectWithValue(error)
        }
    }
)

export const pickSlice = createSlice({
    name: "pick",
    initialState,

    reducers: {
        clearError: (state: PicksListState) => {
            state.error = undefined
        },
        resetSuccess: (state: PicksListState) => {
            state.success = undefined
        },
        resetShipmentTracking: (state: PicksListState) => {
            state.shipmentTracking = undefined
        },
        setScannedSuite: (state: PicksListState, action: PayloadAction<any>) => {
            state.scannedSuite = action.payload || {}
        }
    },

    extraReducers: {
        [loadSuitesPick.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [loadSuitesPick.rejected.toString()]: (state, action) => {
            state.loading = false
            state.error = action.payload?.data?.error || ""
        },
        [loadSuitesPick.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.suitesPick = action.payload?.data?.payload || []
        },

        [loadReadyParcelsPick.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [loadReadyParcelsPick.rejected.toString()]: (state, action) => {
            state.loading = false
            state.error = action.payload?.data?.error || ""
        },
        [loadReadyParcelsPick.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.parcelsBasic = action.payload?.data?.payload || []
        },

        [pickParcel.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [pickParcel.rejected.toString()]: (state, action) => {
            state.loading = false
            state.error = action.payload?.data?.error || ""
        },
        [pickParcel.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.success = true
            state.shipmentTracking = action.payload?.data?.payload || {}
        }
    }
})

export const { clearError, resetSuccess, setScannedSuite } = pickSlice.actions

export default pickSlice.reducer
